<template>
  <PageLoading :loading="loading">
    <!-- 错误页面 -->
    <ErrorPage v-if="hasError" :title="errorTitle" :message="errorMessage" />

    <!-- 正常页面 -->
    <div v-else class="points-page">
      <!-- 积分卡片 -->
      <div class="points-card">
        <div class="points-label">当前积分</div>
        <div class="points-amount">{{ points }}</div>
      </div>

      <!-- 积分明细 -->
      <div class="transaction-section">
        <div class="section-title">积分明细</div>
        <!-- 空状态 -->
        <div v-if="transactions.length === 0" class="empty-state">
          <van-empty description="暂无积分记录" />
        </div>
        <!-- 积分记录列表 -->
        <div v-else>
          <div class="transaction-list">
            <div class="transaction-item" v-for="transaction in transactions" :key="transaction.id">
              <div class="transaction-info">
                <div class="transaction-desc">{{ transaction.name }}</div>
                <div class="transaction-time">{{ transaction.happen_date }}</div>
              </div>
              <div class="transaction-amount" :class="transaction.score > 0 ? 'credit' : 'debit'">
                {{ transaction.score > 0 ? '+' : '' }}{{ transaction.score }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PageLoading>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { setWxTitle } from '@/utils/wx'
import { post } from '@/utils/request'

// 加载状态
const loading = ref(true)

// 错误状态
const hasError = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')

// 当前积分
const points = ref(0)

// 积分记录
const transactions = ref([])

// 处理错误
const handleError = (title, message) => {
  hasError.value = true
  errorTitle.value = title
  errorMessage.value = message
  loading.value = false
}

onMounted(() => {
  setWxTitle('我的积分')
  initPage()
})

// 页面初始化
const initPage = async () => {
  try {
    // 调用接口获取积分信息
    const res = await post('/api/select/community/score/record', {
      partner_id: parseInt(localStorage.getItem('userId')),
      company_ids: JSON.parse(localStorage.getItem('company_ids')),
    })
    if (res.result && res.result.state === 'ok') {
      points.value = res.result.points_account || 0
      transactions.value = res.result.score_record_arr || []
    } else {
      handleError('加载失败', res.result?.message || '接口异常')
    }
  } catch (error) {
    console.error('页面初始化失败:', error)
    handleError('加载失败', '页面加载失败，请重试')
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.points-page {
  min-height: calc(100vh - 32px);
  background: #fff;
  padding: 16px;
}

.points-card {
  background: #FFA500;
  border-radius: 12px;
  padding: 24px;
  color: #fff;
}

.points-label {
  font-size: 14px;
  margin-bottom: 8px;
  opacity: 0.9;
}

.points-amount {
  font-size: 30px;
  font-weight: 500;
}

.section-title {
  padding: 24px 0 16px 0;
  font-size: 18px;
  font-weight: 500;
  color: #000;
}

.transaction-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.transaction-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}

.transaction-info {
  flex: 1;
}

.transaction-desc {
  font-size: 16px;
  color: #000000;
  margin-bottom: 6px;
  font-weight: 500;
}

.transaction-time {
  font-size: 14px;
  color: #6B7280;
}

.transaction-amount {
  font-size: 16px;
  font-weight: 600;
}

.transaction-amount.credit {
  color: #16A34A;
}

.transaction-amount.debit {
  color: #FF4757;
}
</style>